module.exports = __webpack_public_path__ + "img/show.6f80bc56.svg";